import { api } from './http';
import type { AppSurface } from '../appSurface';

export interface VapidPublicKeyResponse {
  public_key: string;
  configured: boolean;
}

/** P3-A12/Task 4's public endpoint — no auth required, since the frontend
 * needs the key before it can even call PushManager.subscribe(). */
export const getVapidPublicKey = () =>
  api.get<VapidPublicKeyResponse>('/push/public-key').then((r) => r.data);

function serializeSubscription(subscription: PushSubscriptionJSON) {
  return {
    endpoint: subscription.endpoint,
    keys: { p256dh: subscription.keys?.p256dh, auth: subscription.keys?.auth },
    user_agent: typeof navigator === 'undefined' ? undefined : navigator.userAgent,
  };
}

export const subscribePush = (subscription: PushSubscriptionJSON, userAgent: string) =>
  api.post('/push/subscribe', {
    ...serializeSubscription(subscription),
    user_agent: userAgent,
  }).then((r) => r.data);

export async function claimTaskAlerts(
  surface: AppSurface,
  subscription: PushSubscriptionJSON,
): Promise<void> {
  await api.post('/push/claim-task-alerts', {
    ...serializeSubscription(subscription),
    app_surface: surface,
  });
}

export const unsubscribePush = (endpoint: string) =>
  api.post('/push/unsubscribe', { endpoint }).then((r) => r.data);
